import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs/internal/observable/throwError';
import { catchError } from 'rxjs/operators';
import * as i2 from '@shared/services.device-id';
class HttpService {
  http;
  deviceIdService;
  constructor(http, deviceIdService) {
    this.http = http;
    this.deviceIdService = deviceIdService;
  }
  createHeaders(additionalHeaders) {
    let headers = new HttpHeaders({
      'device-id': this.deviceIdService.getDeviceId()
    });
    // Cek apakah ada header Content-Type dengan nilai multipart/form-data
    const hasMultipartFormData = additionalHeaders?.some(header => header.key.toLowerCase() === 'content-type' && header.value.toLowerCase().includes('multipart/form-data'));
    // Jika tidak ada Content-Type di additionalHeaders dan bukan multipart/form-data, set ke application/json
    const contentTypeAvailable = additionalHeaders?.some(header => header.key.toLowerCase() === 'content-type');
    if (!contentTypeAvailable && !hasMultipartFormData) {
      headers = headers.append('Content-Type', 'application/json');
    }
    // Tambahkan additionalHeaders, kecuali Content-Type dengan multipart/form-data
    if (additionalHeaders) {
      for (const item of additionalHeaders) {
        if (!(item.key.toLowerCase() === 'content-type' && item.value.toLowerCase().includes('multipart/form-data'))) {
          headers = headers.append(item.key, item.value);
        }
      }
    }
    return headers;
  }
  handleRequest(method, url, options) {
    const request = this.http.request(method, url, options).pipe(catchError(this.handleError));
    return request;
  }
  get(url, params, additionalHeaders, withCredentials) {
    const headers = this.createHeaders(additionalHeaders);
    return this.handleRequest('GET', url, {
      params,
      headers,
      withCredentials
    });
  }
  post(url, body, additionalHeaders, withCredentials) {
    const headers = this.createHeaders(additionalHeaders);
    return this.handleRequest('POST', url, {
      body,
      headers,
      withCredentials
    });
  }
  put(url, body, additionalHeaders) {
    const headers = this.createHeaders(additionalHeaders);
    return this.handleRequest('PUT', url, {
      body,
      headers
    });
  }
  delete(url, additionalHeaders) {
    const headers = this.createHeaders(additionalHeaders);
    return this.handleRequest('DELETE', url, {
      headers
    });
  }
  patch(url, body, additionalHeaders) {
    const headers = this.createHeaders(additionalHeaders);
    return this.handleRequest('PATCH', url, {
      body,
      headers
    });
  }
  handleError(error) {
    return throwError(error);
  }
  static ɵfac = function HttpService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HttpService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.DeviceIdService));
  };
  static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HttpService,
    factory: HttpService.ɵfac,
    providedIn: 'root'
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(HttpService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.HttpClient
  }, {
    type: i2.DeviceIdService
  }], null);
})();

/*
 * Public API Surface of http
 */

/**
 * Generated bundle index. Do not edit.
 */

export { HttpService };
